import { NavLink, useLocation } from "react-router-dom";
import {
	IconDashboard,
	IconUsers,
	IconCrown,
	IconLayoutGrid,
	IconLogout,
} from "@tabler/icons-react";
import { useAuth } from "@/hooks/useAuth";
import { useState } from "react";
import { AdminMenuSheet } from "./AdminMenuSheet";

const ITEMS = [
	{ to: "/manage", label: "Dashboard", icon: IconDashboard, end: true },
	{ to: "/manage/users", label: "Users", icon: IconUsers },
];

export function AdminNav() {
	const { pathname } = useLocation();
	const { signOut } = useAuth();
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<>
			<nav
				className="fixed inset-x-0 bottom-0 z-40 pb-[env(safe-area-inset-bottom)]"
				style={{ background: "var(--color-surface)" }}
			>
				<div
					className="mx-auto flex max-w-[480px] items-stretch justify-between border-t"
					style={{ borderColor: "var(--color-border)" }}
				>
					{ITEMS.map((item) => {
						const active = item.end
							? pathname === item.to
							: pathname.startsWith(item.to);
						return (
							<div key={item.to} className="flex-1">
								<NavLink
									to={item.to}
									end={item.end}
									className="nav-link flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold no-underline"
									style={{
										color: active
											? "var(--color-primary)"
											: "var(--color-text-muted)",
									}}
								>
									<span
										style={{
											display: "inline-flex",
											padding: "0.25rem 0.75rem",
											borderRadius: "var(--radius-full)",
											background: active
												? "var(--color-primary-soft)"
												: "transparent",
										}}
									>
										<item.icon size={20} />
									</span>
									{item.label}
								</NavLink>
							</div>
						);
					})}

					<div className="flex-1">
						<button
							type="button"
							onClick={() => setMenuOpen(true)}
							className="nav-link flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold no-underline w-full"
							style={{
								color: menuOpen
									? "var(--color-primary)"
									: "var(--color-text-muted)",
							}}
						>
							<span
								style={{
									display: "inline-flex",
									padding: "0.25rem 0.75rem",
									borderRadius: "var(--radius-full)",
									background: menuOpen
										? "var(--color-primary-soft)"
										: "transparent",
								}}
							>
								<IconLayoutGrid size={20} />
							</span>
							Menu
						</button>
					</div>

					<div className="flex-1">
						<NavLink
							to="/manage/premium"
							className="nav-link flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold no-underline"
							style={{
								color: pathname.startsWith("/manage/premium")
									? "var(--color-primary)"
									: "var(--color-text-muted)",
							}}
						>
							<span
								style={{
									display: "inline-flex",
									padding: "0.25rem 0.75rem",
									borderRadius: "var(--radius-full)",
									background: pathname.startsWith("/manage/premium")
										? "var(--color-primary-soft)"
										: "transparent",
								}}
							>
								<IconCrown size={20} />
							</span>
							Premium
						</NavLink>
					</div>

					<div className="flex-1">
						<button
							type="button"
							onClick={() => signOut()}
							className="nav-link flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold no-underline w-full"
							style={{ color: "var(--color-text-muted)" }}
						>
							<span
								style={{
									display: "inline-flex",
									padding: "0.25rem 0.75rem",
									borderRadius: "var(--radius-full)",
								}}
							>
								<IconLogout size={20} />
							</span>
							Keluar
						</button>
					</div>
				</div>
			</nav>
			<AdminMenuSheet open={menuOpen} onClose={() => setMenuOpen(false)} />
		</>
	);
}
